import Vue from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';
import { TjipFormComponent } from '@tjip/vuejs';
import { appUploadService } from '@/services/appUploadService';
import { tjipBusyService } from '@/services/tjipBusyService';

@Component({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  validations: AppUploadDocumenten.validations
})
export default class AppUploadDocumenten extends Vue {
  private static validations(this: AppUploadDocumenten) {
    return {
      data: {
        files: {
          required
        }
      }
    };
  }

  @Prop()
  public messageLabel!: string;

  @Prop()
  public uploadUrl!: string;

  @Ref('form')
  private formCtrl!: TjipFormComponent;

  public data = {
    files: []
  };
  public serverError: string | boolean = false;

  public get resolvedButtonClass(): string {
    return `btn-ppf${this.data.files.length ? ' btn-secondary' : ''}`;
  }

  public get submitButtonClass(): string {
    return this.data.files.length ? '' : 'btn-secondary';
  }

  public send() {
    tjipBusyService.add(
      appUploadService
        .upload(this.uploadUrl, this.data.files)
        .then(() => {
          this.uploadSucceeded();
        })
        .catch(res => {
          this.serverError = res;
        })
    );
  }

  public uploadSucceeded() {
    this.formCtrl.reset();
    this.$emit('uploadSucceeded');
  }

  @Watch('data.files')
  private watchFiles() {
    this.serverError = false;
  }
}
